module.exports = __webpack_public_path__ + "img/devise-ideation.c2199255.jpg";